<template>
  <main class="main main--has-floating-buttons">
    <portal to="headerTitle">
      {{ $t('admin.pagePrivacyPolicies.title') }}
    </portal>
    <card :title="$t('admin.pagePrivacyPolicies.card.title')" cols="12">
      <hm-card-inner v-if="!isSystemRootInstance" :full-size="true">
        <template v-for="type in enums['PrivacyPolicyType']">
          <hm-card-inner-line :title="$t(`layout.nav.admin.privacyPolicyNav.${type}`)"
                              :clickable="true"
                              @click="routeToPrivacyPolicy(type, hotelSettings.details.countryCode)" />
        </template>
      </hm-card-inner>
    </card>
  </main>
</template>

<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import { cloneDeep, first, groupBy, isEmpty, isEqual, isNil, keyBy, map, maxBy, pullAt, sortBy } from 'lodash';
import SaveWatchMixin from '@/mixins/SaveWatchMixin';
import HmCardInner from '../../lib/layout/HmCardInner';
import HmMultiselect from '../../lib/inputs/HmMultiselect';
import HmButton from '../../lib/buttons/HmButton';
import uuid from 'uuid';
import TabableCard from '../../lib/layout/TabableCard';
import TabableCardContent from '../../lib/layout/TabableCardContent';
import Card from '../../lib/layout/Card.vue';
import HmCardInnerLine from '../../lib/layout/HmCardInnerLine.vue';

export default {
  name: 'PagePrivacyPolicy',
  components: { HmCardInnerLine, HmCardInner, Card, TabableCardContent, TabableCard },
  mixins: [HotelmeisterMixin],

  data() {
    return {
    };
  },

  computed: {
    isSystemRootInstance: function () {
      return ['system', 'hotelmeister'].includes(this.hotelSettings.tenant.subdomain.toLowerCase());
    },
  },

  watch: {
  },

  created: function () {
  },

  methods: {
    routeToPrivacyPolicy: function (type, countryCode) {
      this.$router.push({ name: 'privacyPolicy', params: { type: type, countryCode: countryCode } });
    },
  },

};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
</style>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/pages/admin/PagePrivacyPolicies.vue